<div class="container-fluid px-0">
  <div class="ship-toolbar">
    <div class="toolbar-left">
      <span class="toolbar-label">Filter by</span>
      <div class="date-filter status-filter" ngbDropdown #statusDrop="ngbDropdown" autoClose="outside" display="static" (openChange)="onStatusMenuOpenChange($event)">
        <button type="button" class="date-filter-btn" [class.has-clear]="statusSelected.length" ngbDropdownToggle aria-label="Status">
          <span class="status-label">
            <img src="assets/icons/data-table/filter.svg" alt="" width="16" height="16" />
            {{ statusLabel }}
          </span>
          <img class="chevron" src="assets/icons/data-table/chevron.svg" alt="" width="10" height="6" />
        </button>
        <button
          *ngIf="statusSelected.length"
          type="button"
          class="clear-btn clear-btn--status"
          aria-label="Clear status filter"
          (click)="$event.stopPropagation(); clearStatuses(); statusDrop.close()"
        >
          <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>
        <div class="dropdown-menu status-menu" ngbDropdownMenu>
          <div class="status-search">
            <input type="search" [(ngModel)]="statusSearch" placeholder="Search status..." aria-label="Search status" />
          </div>
          <div class="status-options">
            <label *ngFor="let option of filteredStatusOptions" class="status-option">
              <input type="checkbox" [checked]="statusSelected.includes(option.value)" (change)="toggleStatus(option.value)" />
              {{ option.label }}
            </label>
            <div *ngIf="!filteredStatusOptions.length" class="status-empty">No statuses found</div>
          </div>
        </div>
      </div>
    </div>

    <div class="toolbar-right">
      <app-saved-search
        #savedSearch
        [gridApi]="gridApi"
        [viewFilterType]="viewFilterType"
        [module]="module"
        [pinnedColumns]="pinnedColumns"
        (onClearFilters)="clearFiltersExternally()"
      ></app-saved-search>
    </div>
  </div>

  <div class="row" *ngIf="customerId != null">
    <ag-grid-angular
      tkGrid
      class="w-100"
      style="height: 600px"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [appSavedSearchSync]="savedSearch"
      [savedSearchDeferRefresh]="true"
      (filterChanged)="onFilterChanged()"
      (paginationChanged)="onPaginationChanged()"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </div>
</div>
